// extracted by mini-css-extract-plugin
export default {"main":"styles_main__AxxHv","header":"styles_header__SkGDJ","text":"styles_text__GECYs"};